import { create } from "zustand";
import { getCurrentWeekStats } from "@/services/EmployeeService/AttendanceService";
import { registerStoreReset } from "@/store/storeResetUtils";

interface WeekDay {
  date: string;
  dayName: string;
  dayShort: string;
  hours: number;
  displayText?: string;
  punch_in: string | null;
  punch_out: string | null;
  status: string | null;
}

interface WeekStats {
  weekDays: WeekDay[];
  totalWeekHours: number;
  weekStart: string;
  weekEnd: string;
}

interface EmployeeDashboardStore {
  // State
  weekStats: WeekStats | null;
  loading: boolean;
  error: string | null;

  // Actions
  fetchWeekStats: () => Promise<void>;
  resetError: () => void;
  resetStore: () => void;
}

const useEmployeeDashboardStore = create<EmployeeDashboardStore>((set) => ({
  // Initial state
  weekStats: null,
  loading: false,
  error: null,

  // Fetch current week stats
  fetchWeekStats: async () => {
    try {
      set({ loading: true, error: null });

      const response = await getCurrentWeekStats();
      console.log("Week Stats API Response:", response);

      if (response.success) {
        set({ weekStats: response.data, loading: false });
      } else {
        set({
          error: response.error?.message || 'Failed to fetch week stats',
          loading: false
        });
      }
    } catch (error: any) {
      console.error("Fetch Week Stats Error:", error);
      set({ error: error.message, loading: false });
    }
  },

  // Reset error
  resetError: () => set({ error: null }),

  // Reset store to initial state
  resetStore: () => set({
    weekStats: null,
    loading: false,
    error: null
  })
}));

// Register this store for centralized reset
registerStoreReset('employeeDashboard', () => useEmployeeDashboardStore.getState().resetStore());

export default useEmployeeDashboardStore;
